<template>
  <div>
    <label>{{ data.titleLang | setText(data.title) }}</label>
    <select @change="input" v-model="val" class="form-control mb-2">
      <option value="">Выберите</option>
      <option :value="l['value']" v-for="(l, k) in data.data" :key="k">
        {{ l["titleLang"] | setText(l["title"]) }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      default: function () {
        return {
          data: [],
          tilte: "",
          tilteLang: "",
        };
      },
    },
  },

  methods: {
    input() {
      setTimeout(() => {
        this.$emit("input", this.val);
      }, 10);
    },
  },
  data() {
    return {
      val: null,
    };
  },
};
</script>

